import { History } from "lucide-react";

const fmtDT = (s) => {
  try {
    return new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return "-";
  }
};

const MINOR_ACTIONS = [
  "Modification des critères (étape 1)",
  "Mise à jour des détails (étape 2)",
  "Acceptation de l'offre — code de validation envoyé",
  "Bon de commande PDF ajouté",
];

export const OrderHistory = ({ history }) => {
  const entries = (history || []).filter((h) => !MINOR_ACTIONS.includes(h.action));
  if (entries.length === 0) return null;
  return (
    <div data-testid="order-history">
      <div className="lc-small-label mb-2 flex items-center gap-1.5">
        <History className="w-3 h-3 text-[var(--lc-orange)]" /> Historique
      </div>
      <div className="space-y-1.5">
        {[...entries].reverse().map((h, i) => (
          <div key={i} className="flex items-start gap-2 text-xs bg-[var(--lc-surface)] rounded p-2" data-testid={`history-entry-${i}`}>
            <span className="font-mono text-[var(--lc-gray)] shrink-0">{fmtDT(h.at)}</span>
            <span><span className="font-semibold">{h.actor}</span> — {h.action}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
